import React from 'react';

export default function References() {
  const isSmallScreen = window.innerWidth <= 768;

  return (
    <div style={{marginTop: '10vh', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10vh'}}>
      <div style={{zIndex: 10, position: 'relative', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>

        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '40px', zIndex: 10, position: 'relative'}}>
          <div style={{
            width: isSmallScreen ? '40px' : 'clamp(80px, 25vw, 600px)',
            height: '3px',
            backgroundColor: '#333333',
          }}></div>
          <div style={{fontSize: isSmallScreen ? '35px' : '55px', color: '#333333', textAlign: 'center'}}>
            References
          </div>
          <div style={{
            width: isSmallScreen ? '40px' : 'clamp(80px, 25vw, 600px)',
            height: '3px',
            backgroundColor: '#333333',
          }}></div>
        </div>

        <div style={{
          maxWidth: isSmallScreen ? '90vw' : '800px',
          width: '100%',
          marginTop: '40px',
          padding: isSmallScreen ? '20px' : '40px',
          color: '#333333',
          fontSize: isSmallScreen ? '16px' : '18px',
          lineHeight: '1.8'
        }}>
          <p style={{
            marginBottom: '40px',
            textAlign: 'center',
            fontSize: isSmallScreen ? '16px' : '18px',
            lineHeight: '1.6'
          }}>
            Being easy to work with is extremely important to me! The individuals below have eagerly volunteered to attest to my work ethic, attitude and professionalism. Please do not hesitate to ask them questions.
          </p>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '40px'
          }}>
            {/* Yousef Saleh */}
            <div style={{
              padding: isSmallScreen ? '20px' : '30px',
              borderRadius: '20px',
              backgroundColor: 'white',
              boxShadow: '0px 4px 6px rgba(0, 0.1, 0.1, 0.5)'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: isSmallScreen ? 'column' : 'row',
                justifyContent: 'space-between',
                alignItems: isSmallScreen ? 'flex-start' : 'flex-start',
                marginBottom: '15px',
                gap: isSmallScreen ? '10px' : '0'
              }}>
                <div style={{
                  fontSize: isSmallScreen ? '20px' : '24px',
                  fontWeight: '600',
                  color: '#333333'
                }}>
                  Yousef Saleh
                </div>
                <a 
                  href="mailto:yousef.saleh@ninjatrader.com" 
                  style={{ 
                    color: '#004499', 
                    textDecoration: 'underline', 
                    cursor: 'pointer',
                    fontSize: isSmallScreen ? '16px' : '18px'
                  }}
                >
                  yousef.saleh@ninjatrader.com
                </a>
              </div>
              <p style={{
                margin: 0,
                fontSize: isSmallScreen ? '16px' : '18px',
                lineHeight: '1.6'
              }}>
                Yousef was assigned to be my mentor during my Summer '25 internship at NinjaTrader. Having sat next to him, a senior software engineer, everyday for three months, I highly encourage you to reach out to him to get a sense of what it is like to work with me.
              </p>
            </div>

            {/* Eli Lewitt */}
            <div style={{
              padding: isSmallScreen ? '20px' : '30px',
              borderRadius: '20px',
              backgroundColor: 'white',
              boxShadow: '0px 4px 6px rgba(0, 0.1, 0.1, 0.5)'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: isSmallScreen ? 'column' : 'row',
                justifyContent: 'space-between',
                alignItems: isSmallScreen ? 'flex-start' : 'flex-start',
                marginBottom: '15px',
                gap: isSmallScreen ? '10px' : '0'
              }}>
                <div style={{
                  fontSize: isSmallScreen ? '20px' : '24px',
                  fontWeight: '600',
                  color: '#333333'
                }}>
                  Eli Lewitt
                </div>
                <a 
                  href="mailto:eli@myfye.com" 
                  style={{ 
                    color: '#004499', 
                    textDecoration: 'underline', 
                    cursor: 'pointer',
                    fontSize: isSmallScreen ? '16px' : '18px'
                  }}
                >
                  eli@myfye.com
                </a>
              </div>
              <p style={{
                margin: 0,
                fontSize: isSmallScreen ? '16px' : '18px',
                lineHeight: '1.6'
              }}>
                Eli is the founder of Myfye, a decentralized banking app. As a non technical financial lawyer, he relied on me to bring the technical skills to develop his vision.
              </p>
            </div>

            {/* Jordan Finn */}
            <div style={{
              padding: isSmallScreen ? '20px' : '30px',
              borderRadius: '20px',
              backgroundColor: 'white',
              boxShadow: '0px 4px 6px rgba(0, 0.1, 0.1, 0.5)'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: isSmallScreen ? 'column' : 'row',
                justifyContent: 'space-between',
                alignItems: isSmallScreen ? 'flex-start' : 'flex-start',
                marginBottom: '15px',
                gap: isSmallScreen ? '10px' : '0'
              }}>
                <div style={{
                  fontSize: isSmallScreen ? '20px' : '24px',
                  fontWeight: '600',
                  color: '#333333'
                }}>
                  Jordan Finn
                </div>
                <a 
                  href="mailto:finnj1@uci.edu" 
                  style={{ 
                    color: '#004499', 
                    textDecoration: 'underline', 
                    cursor: 'pointer',
                    fontSize: isSmallScreen ? '16px' : '18px'
                  }}
                >
                  finnj1@uci.edu
                </a>
              </div>
              <p style={{
                margin: 0,
                fontSize: isSmallScreen ? '16px' : '18px',
                lineHeight: '1.6'
              }}>
                Jordan is my classmate studying Computer Science at UC Irvine. He worked with me on a project during my time at Blockchain At UCI. As the tech lead, I gave him a technical interview before assigning tasks to him.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

